<article class="flex items-center justify-center h-full box-border gap-6 p-2 rounded-[28px] bg-neptune-gradient">
<div class="flex items-center justify-start gap-4 w-full h-full box-border px-6 py-4 rounded-[20px] bg-white/15">
    <div class="flex w-12 h-12">
      <img src="assets/service-insights/{{ icon }}.svg" alt="{{ title }}" />
    </div>

    <div class="flex flex-col">
      <!-- Smaller title between md–xl breakpoints to accommodate the tighter grid column width -->
      <span class="text-white text-xl md:text-lg xl:text-xl font-normal leading-6">
        {{ title }}
      </span>

      <ng-container *ngIf="loading; else valueDisplay">
        <div class="animate-pulse bg-white/30 rounded-md h-8 w-24 mt-1"></div>
      </ng-container>
      <ng-template #valueDisplay>
        <span class="text-white text-2xl md:text-[28px] font-bold leading-8">
          {{ formattedValue }}
        </span>
      </ng-template>
    </div>
    </div>
</article>
